import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { EErrorCode } from '../entities/error-code';
import { NavigationService } from '../services/navigation.service';

const isConnectionError = (errorMessage: string) =>
  [/Loading chunk .* failed/, /"status":0,"statusText":"Unknown Error"/, /0 Unknown Error/].some((regex) =>
    regex.test(errorMessage)
  );

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: Error) {
    if (isConnectionError(error.message)) {
      // alert('error: ' + JSON.stringify(error));
      // tslint:disable-next-line:no-console
      console.info('Offline mode');

      const navigationService: NavigationService = this.injector.get(NavigationService);

      navigationService.goToErrorPage(EErrorCode.Error_0_offline);
    } else {
      console.log('something went wrong', error);
      // Re-throw the error for browser's console
      throw error;
    }
  }
}
